import { MagicConfigMixin } from '@gig/magic-common';
import { Mixins, Component } from 'vue-property-decorator';
import { magic } from '@gig/magic-sdk';
import { USER_JURISDICTION_QUERY, RESET_GAME_SESSION_COMMAND } from '@gig/magic-messages';
import { Jurisdiction } from '@gig/magic-jurisdictions';
import { namespace } from 'vuex-class';
import { GAME_SESSION_NAMESPACE } from '../../store/modules/game-session/game-session.constants.js';
import '../../store/modules/game-session/game-session.store.js';
import { store } from '../../store/index.js';

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const gameSessionModule = namespace(GAME_SESSION_NAMESPACE);
let SessionSummaryManagerComponent = class extends Mixins(MagicConfigMixin) {
  constructor() {
    super(...arguments);
    this.subscriptions = [];
    this.currentJurisdiction = null;
    this.resetGameSessionSummarySubscription = null;
  }
  created() {
    return __async(this, null, function* () {
      this.currentJurisdiction = yield window.queryBus.query(USER_JURISDICTION_QUERY);
      if (this.currentJurisdiction === Jurisdiction.LOTBA || this.currentJurisdiction === Jurisdiction.AGCO || this.currentJurisdiction === Jurisdiction.EMTA) {
        this.getGameSessionSummary();
      }
      this.subscriptions.push(magic.events.gameSessionSummary((payload) => {
        this.setGameSessionSummary(payload);
      }).unsub);
      this.resetGameSessionSummarySubscription = window.commandBus.subscribe(RESET_GAME_SESSION_COMMAND, () => {
        this.resetGameSessionSummary();
      });
    });
  }
  getGameSessionSummary() {
    return __async(this, null, function* () {
      yield this.fetchGameSessionSummary();
    });
  }
  render() {
    return null;
  }
  destroyed() {
    var _a;
    this.subscriptions.forEach((unsub) => unsub());
    (_a = this.resetGameSessionSummarySubscription) == null ? void 0 : _a.unsubscribe();
  }
};
__decorateClass([
  gameSessionModule.Action("fetchGameSessionSummary")
], SessionSummaryManagerComponent.prototype, "fetchGameSessionSummary", 2);
__decorateClass([
  gameSessionModule.Action("resetGameSessionSummary")
], SessionSummaryManagerComponent.prototype, "resetGameSessionSummary", 2);
__decorateClass([
  gameSessionModule.Action("setGameSessionSummary")
], SessionSummaryManagerComponent.prototype, "setGameSessionSummary", 2);
__decorateClass([
  gameSessionModule.Getter("betsPlaced")
], SessionSummaryManagerComponent.prototype, "betsPlaced", 2);
__decorateClass([
  gameSessionModule.Getter("betWins")
], SessionSummaryManagerComponent.prototype, "betWins", 2);
SessionSummaryManagerComponent = __decorateClass([
  Component({
    name: "session-summary-manager",
    store
  })
], SessionSummaryManagerComponent);

export { SessionSummaryManagerComponent };
